<template>
  <div>
    <div class="top">
      <div
        class="top-title"
        @click="
          $router.push(`/predictions/heatmaps/${$route.params.heatmapId}`)
        "
      >
        <div>
          <transition name="slide-fade">
            <span style="font-weight: 500;"
              >&#128072; back to heatmap
              <span v-if="heatmap">{{ heatmap.title }}</span></span
            >
          </transition>
        </div>
      </div>
      <div class="right-top">
        <div style="display: flex; gap: 20px;">
          <div class="variants">
            <div
              v-bind:class="{ active: variant === 'Heatmap' }"
              class="v1 option"
              @click="
                variant = 'Heatmap';
                showBoxes = true;
              "
            >
              heatmap
            </div>
            <div
              v-bind:class="{ active: variant === 'Peekthrough' }"
              class="v2 option"
              @click="
                showBoxes = false;
                variant = 'Peekthrough';
              "
            >
              peekthrough
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comparison">
      <div class="v1" v-if="heatmap">
        <div class="compare-title">
          <p style="font-weight: 600">{{ heatmap.title }}</p>
        </div>
        <div class="position" v-bind:class="{ portrait: portraitHeatmap }">
          <div class="image-wrapper">
            <Heatmap
              ref="heatmap"
              :variant="variant"
              :data="heatmapData"
              :loadBoxes="heatmap.areas_of_interest"
              :image="heatmap.image"
              :image_result="heatmap.image_result"
              :peekthrough="heatmap.peekthrough"
              :heatmap="heatmap.heatmap"
              opacity="0.3"
              :showBoxes="showBoxes"
              :disabled="true"
              :originalWidth="originalWidth"
              @boxUpdate="updateBoxes"
              @onSelectBox="selectBox"
            />
          </div>
          <div class="box-wrapper">
            <div
              v-for="(box, index) in boxes"
              :key="index"
              class="box"
              :style="{ width: boxesWidth }"
            >
              <p>
                {{ box.name }}
              </p>
              <p style="color: #0931F0;">
                <b>{{ Math.floor(box.value * 100) }}%</b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="v2">
        <bg-select
          style="margin-top: 20px;"
          :options="heatmaps"
          label="title"
          @change="onSelect"
          placeholder="Select a heatmap to compare"
        ></bg-select>
        <div
          class="position"
          v-bind:class="{ portrait: portraitCompare }"
          v-if="compare"
        >
          <Heatmap
            ref="compare"
            :variant="variant"
            :data="compareData"
            :loadBoxes="compare.areas_of_interest"
            :image="compare.image"
            :image_result="compare.image_result"
            :peekthrough="compare.peekthrough"
            :heatmap="compare.heatmap"
            opacity="0.3"
            :showBoxes="showBoxes"
            :disabled="true"
            :originalWidth="originalWidthCompare"
            @boxUpdate="updateBoxesCompare"
          />
          <div class="box-wrapper">
            <div
              v-for="(box, index) in boxesCompare"
              :key="index"
              class="box"
              :style="{ width: boxesWidthCompare }"
            >
              <p>
                {{ box.name }}
              </p>
              <p style="color: #0931F0;">
                <b>{{ Math.floor(box.value * 100) }}%</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BgButton from "@/components/bg-button";
import BgSelect from "@/components/bg-select";
import Heatmap from "../heatmap/heat";
import BgTypography from "@/directives/bg-typography";
import BgIcon from "@/components/bg-icon";
import API from "@/api";

export default {
  components: {
    BgButton,
    BgSelect,
    Heatmap,
    BgIcon,
  },
  directives: {
    BgTypography,
  },
  async created() {
    this.isLoading = true;
    const result = await API.test.getPrediction(this.$route.params.heatmapId);
    await this.createTestHeatmap(result);
    const heatmaps = await API.test.getPredictions();

    this.heatmap = result;
    heatmaps.forEach((element) => {
      if (element.image) {
        this.heatmaps.push(element);
      }
    });
    let img = new Image();
    img.src = this.heatmap.image;
    img.onload = () => {
      this.width = img.width;
      this.height = img.height;
    };

    this.selected = result;
  },
  computed: {
    portraitHeatmap() {
      return this.width < this.height;
    },
    portraitCompare() {
      return this.widthCompare < this.heightCompare;
    },
    boxesWidth() {
      if (this.portraitHeatmap) {
        return "90%";
      } else {
        return "60%";
      }
    },
    boxesWidthCompare() {
      if (this.portraitCompare) {
        return "90%";
      } else {
        return "60%";
      }
    },
  },
  data() {
    return {
      activeBoxIndex: null,
      boxes: [],
      boxesCompare: [],
      compare: null,
      compareData: [],
      heatmap: null,
      heatmapData: [],
      heatmaps: [],
      originalWidth: null,
      originalWidthCompare: null,
      selected: null,
      showBoxes: true,
      width: null,
      widthCompare: null,
      height: null,
      heightCompare: null,
      variant: "Heatmap",
    };
  },
  methods: {
    async createTestHeatmap(val) {
      this.heatmapData = [];
      const imageOriginal = await fetch(val.image);
      const imgblobOriginal = await imageOriginal.blob();
      const imgOriginal = await createImageBitmap(imgblobOriginal);
      this.originalWidth = imgOriginal.width;

      const image = await fetch(val.image_mask);
      const imgblob = await image.blob();
      const img = await createImageBitmap(imgblob);
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ratio = this.originalWidth / img.width;

      canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);

      // this.heatmap.clarity = {
      //   x: [],
      //   y: [],
      // };

      for (let x = 0; x < img.width + 100; x++) {
        for (let y = 0; y < img.height + 100; y++) {
          var pixelData = canvas.getContext("2d").getImageData(x, y, 1, 1).data;
          const Y =
            0.2126 * pixelData[0] +
            0.7152 * pixelData[1] +
            0.0722 * pixelData[2];

          // if (Y > 150) {
          //   if (!this.heatmap.clarity.x.includes(x)) {
          //     this.heatmap.clarity.x.push(x);
          //   }
          //   if (!this.heatmap.clarity.y.includes(y)) {
          //     this.heatmap.clarity.y.push(y);
          //   }
          // }

          this.heatmapData.push({
            x: x * ratio,
            y: y * ratio,
            value: Y * (ratio / 100),
          });
        }
      }

      this.isLoading = false;
      return true;
    },
    async createCompareHeatmap(val) {
      this.compareData = [];
      const imageOriginal = await fetch(val.image);
      const imgblobOriginal = await imageOriginal.blob();
      const imgOriginal = await createImageBitmap(imgblobOriginal);
      this.originalWidthCompare = imgOriginal.width;

      const image = await fetch(val.image_mask);
      const imgblob = await image.blob();
      const img = await createImageBitmap(imgblob);
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ratio = this.originalWidthCompare / img.width;

      canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);

      // this.heatmap.clarity = {
      //   x: [],
      //   y: [],
      // };

      for (let x = 0; x < img.width + 100; x++) {
        for (let y = 0; y < img.height + 100; y++) {
          var pixelData = canvas.getContext("2d").getImageData(x, y, 1, 1).data;
          const Y =
            0.2126 * pixelData[0] +
            0.7152 * pixelData[1] +
            0.0722 * pixelData[2];

          // if (Y > 150) {
          //   if (!this.heatmap.clarity.x.includes(x)) {
          //     this.heatmap.clarity.x.push(x);
          //   }
          //   if (!this.heatmap.clarity.y.includes(y)) {
          //     this.heatmap.clarity.y.push(y);
          //   }
          // }

          this.compareData.push({
            x: x * ratio,
            y: y * ratio,
            value: Y * (ratio / 100),
          });
        }
      }

      this.isLoading = false;
      return true;
    },
    async onSelect(val) {
      this.compare = null;
      await this.createCompareHeatmap(val);
      let img = new Image();
      img.src = val.image;
      img.onload = () => {
        this.widthCompare = img.width;
        this.heightCompare = img.height;
      };
      this.compare = val;
    },
    selectBox(val) {
      this.activeBoxIndex = val;
    },
    updateBoxes(val) {
      this.activeBoxIndex = null;
      this.boxes = val;
    },
    updateBoxesCompare(val) {
      this.activeBoxIndex = null;
      this.boxesCompare = val;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./styles.scss";
</style>
